import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.scss';

const Inset = ({ children, transparent, className }) => {
  const classNames = [styles.container];
  if (transparent) {
    classNames.push(styles.transparent);
  }
  if (className) {
    classNames.push(className);
  }

  return <div className={classNames.join(' ')}>{children}</div>;
};

Inset.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  transparent: PropTypes.bool
};

Inset.defaultProps = {
  className: null,
  transparent: false
};

export default Inset;
